import React from 'react';
import { getProductEditModel } from './productEditFormModel';
import { ProductEditForm } from './productEditForm';

export function ProductNew(props) {
  const model = getProductEditModel({});
  console.log(model)

  return <ProductEditForm model={model} />
}